var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { AlipayInfoService } from "~/services/repair-service/alipayInfo.service";
var AddAlipayData = /** @class */ (function (_super) {
    __extends(AddAlipayData, _super);
    function AddAlipayData() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kosekiModel = {
            name: "",
            idNo: "",
            kosekiArea: "",
            koseki: ""
        };
        _this.loading = {
            state: false
        };
        _this.dialog = {
            detail: false
        };
        _this.rulesAdd = {
            name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
            idNo: [{ required: true, message: "请输入身份证号", trigger: "blur" }]
        };
        return _this;
    }
    AddAlipayData.prototype.success = function () {
        this.close();
    };
    AddAlipayData.prototype.close = function () {
        this.reset();
    };
    AddAlipayData.prototype.mounted = function () { };
    // 保存支付宝资料
    AddAlipayData.prototype.AddDetail = function () {
        var _this = this;
        var addform = this.$refs["add-form"];
        addform.validate(function (valid) {
            if (!valid)
                return;
            _this.loading.state = true;
            _this.alipayInfoService
                .insert(_this.kosekiModel, _this.loading)
                .subscribe(function (data) {
                _this.$message.success("添加成功!");
                _this.success();
            });
        });
    };
    AddAlipayData.prototype.reset = function () {
        var add = this.$refs["add-form"];
        add.resetFields();
    };
    __decorate([
        Dependencies(AlipayInfoService)
    ], AddAlipayData.prototype, "alipayInfoService", void 0);
    __decorate([
        Emit("success")
    ], AddAlipayData.prototype, "success", null);
    __decorate([
        Emit("close")
    ], AddAlipayData.prototype, "close", null);
    AddAlipayData = __decorate([
        Component({
            components: {}
        })
    ], AddAlipayData);
    return AddAlipayData;
}(Vue));
export default AddAlipayData;
